export default __webpack_public_path__ + "static/media/postgres-dark.e1069679.png";